export const ERR = {
  NETWORK: 'network',
  NETWORK_TIMEOUT: 'network_timeout',
  OPTION: 'option',
  M3U8: 'm3u8',
  DEMUX: 'demux',
  REMUX: 'remux',
  MSE: 'mse',
  DECRYPT: 'decrypt',
  OTHER: 'other'
}

export const ERR_CODE = {
  [ERR.OPTION]: 500,
  [ERR.NETWORK]: 600,
  [ERR.NETWORK_TIMEOUT]: 601,
  [ERR.M3U8]: 900,
  [ERR.DEMUX]: 700,
  [ERR.DECRYPT]: 701,
  [ERR.REMUX]: 800,
  [ERR.MSE]: 1000,
  [ERR.OTHER]: 999
}

export class StreamingError extends Error {
  constructor (type, origin, payload, msg) {
    super(msg || origin?.message)
    this.errorType = type === ERR.NETWORK_TIMEOUT ? ERR.NETWORK : type
    this.originError = origin
    this.ext = payload
    this.errorCode = ERR_CODE[type]
    this.errorMessage = this.message
    if (!this.errorCode) {
      this.errorType = ERR.OTHER
      this.errorCode = ERR_CODE[this.errorType]
    }
  }

  static create (type, origin, payload, msg) {
    if (type instanceof StreamingError) {
      return type
    } else if (type instanceof Error) {
      origin = type
      type = ''
    }

    if (!type) type = ERR.OTHER

    return new StreamingError(type, origin, payload, msg)
  }

  static network (error) {
    return new StreamingError(error?.isTimeout ? ERR.NETWORK_TIMEOUT : ERR.NETWORK, error, {
      url: error?.url,
      response: error?.response,
      httpCode: error?.response?.status
    })
  }
}
